import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { SalesContext } from '@/hooks/api/models';

/**
 * 2130. 売上タイプ一覧
 * [GET] /sales_contexts
 */
const salesContexts = (): Promise<SalesContext[]> => {
  return axios.get(`/api/sales_contexts`);
};

export const useSalesContexts = () => {
  return useQuery({
    queryKey: ['sales_contexts'],
    queryFn: () => salesContexts(),
  });
};
